module.exports = __webpack_public_path__ + "img/symbol_3.ffe16912.png";